import { z } from 'zod';

export const TabelaComissaoProdutoPartialSchema = z.object({
    pro_codigo_interno: z.number(),
    pro_descricao: z.string(),
    pro_preco_minimo: z.number().nullable(),
    pro_preco_venda: z.number().nullable(),
    pro_sku: z.string().nullable(),
});

export type TabelaComissaoProdutoPartial = z.infer<typeof TabelaComissaoProdutoPartialSchema>;
